module.exports = __webpack_public_path__ + "media/src/assets/images/property-1e74c77dd563ddb59069fc806c4c5e27.jpg";